import { render, staticRenderFns } from "./IconEllipse.vue?vue&type=template&id=3bcd62cb&"
import script from "./IconEllipse.vue?vue&type=script&lang=ts&"
export * from "./IconEllipse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports